import { render, staticRenderFns } from "./ProductsSwiper.vue?vue&type=template&id=0a5aa568&scoped=true"
import script from "./ProductsSwiper.vue?vue&type=script&lang=ts"
export * from "./ProductsSwiper.vue?vue&type=script&lang=ts"
import style0 from "./ProductsSwiper.vue?vue&type=style&index=0&id=0a5aa568&prod&lang=scss"
import style1 from "./ProductsSwiper.vue?vue&type=style&index=1&id=0a5aa568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5aa568",
  null
  
)

export default component.exports